import { render, staticRenderFns } from "./selectBindAccount.vue?vue&type=template&id=0507bb2f&scoped=true"
import script from "./selectBindAccount.vue?vue&type=script&lang=js"
export * from "./selectBindAccount.vue?vue&type=script&lang=js"
import style0 from "./selectBindAccount.vue?vue&type=style&index=0&id=0507bb2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507bb2f",
  null
  
)

export default component.exports